module.exports = __webpack_public_path__ + "img/99.7e80f132.png";